/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetNoContractAdditionalInfoDto } from './GetNoContractAdditionalInfoDto';
import {
    GetNoContractAdditionalInfoDtoFromJSON,
    GetNoContractAdditionalInfoDtoFromJSONTyped,
    GetNoContractAdditionalInfoDtoToJSON,
} from './GetNoContractAdditionalInfoDto';

/**
 * 
 * @export
 * @interface ChecklistItemDto
 */
export interface ChecklistItemDto {
    /**
     * 
     * @type {string}
     * @memberof ChecklistItemDto
     */
    stepDefinitionId: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItemDto
     */
    stepType: ChecklistItemDtoStepTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItemDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ChecklistItemDto
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItemDto
     */
    deadline: ChecklistItemDtoDeadlineEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ChecklistItemDto
     */
    automatic: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItemDto
     */
    priority: ChecklistItemDtoPriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItemDto
     */
    stageDefinitionId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChecklistItemDto
     */
    completed: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItemDto
     */
    statusMessage: string;
    /**
     * 
     * @type {Array<GetNoContractAdditionalInfoDto>}
     * @memberof ChecklistItemDto
     */
    additionalInfo?: Array<GetNoContractAdditionalInfoDto>;
}


/**
 * @export
 */
export const ChecklistItemDtoStepTypeEnum = {
    AtLeastOneProfilePerMonth: 'AtLeastOneProfilePerMonth',
    NoMediaplanForMediaProfileInCurrentMonth: 'NoMediaplanForMediaProfileInCurrentMonth',
    AtLeastOneItemAdded: 'AtLeastOneItemAdded',
    MediaplanApprovedByClient: 'MediaplanApprovedByClient',
    AllItemsWithAmountsEnteredForCurrentMonth: 'AllItemsWithAmountsEnteredForCurrentMonth',
    RequiredCampaignDocumentsAdded: 'RequiredCampaignDocumentsAdded',
    CurrentMonthReadyForInvoicing: 'CurrentMonthReadyForInvoicing',
    SpecialInvoicingRequest: 'SpecialInvoicingRequest',
    ProjectCancelledRequest: 'ProjectCancelledRequest',
    ProjectDateChangeRequest: 'ProjectDateChangeRequest',
    CheckContractsCoverage: 'CheckContractsCoverage',
    ContractsSignedByResponsiblePerson: 'ContractsSignedByResponsiblePerson',
    NoContract: 'NoContract',
    ContractSent: 'ContractSent',
    OrderCreatedForSpecialistTeam: 'OrderCreatedForSpecialistTeam',
    OrderApprovedBySpecialistTeam: 'OrderApprovedBySpecialistTeam',
    OrderExecutionCreated: 'OrderExecutionCreated',
    OrderExecutionApproved: 'OrderExecutionApproved',
    OrderExecutionPositionsSumValidation: 'OrderExecutionPositionsSumValidation',
    MonthlySettlementReminder: 'MonthlySettlementReminder',
    StatusConfirmedByDocuments: 'StatusConfirmedByDocuments',
    SalesSettlementCompleted: 'SalesSettlementCompleted',
    PendingFvzAssignedToCampaign: 'PendingFVZAssignedToCampaign',
    MissingFvz: 'MissingFVZ',
    PurchaseSettlementCompleted: 'PurchaseSettlementCompleted',
    CampaignsWithBlockingInvoicingErrors: 'CampaignsWithBlockingInvoicingErrors',
    SalesInvoiceSent: 'SalesInvoiceSent',
    MediaplanCorrection: 'MediaplanCorrection'
} as const;
export type ChecklistItemDtoStepTypeEnum = typeof ChecklistItemDtoStepTypeEnum[keyof typeof ChecklistItemDtoStepTypeEnum];

/**
 * @export
 */
export const ChecklistItemDtoDeadlineEnum = {
    SinceProjectCreation: 'SinceProjectCreation',
    LastMonthEnd: 'LastMonthEnd',
    FifteenthOfCurrentMonth: 'FifteenthOfCurrentMonth',
    CurrentMonthEnd: 'CurrentMonthEnd',
    FifteenthOfNextMonth: 'FifteenthOfNextMonth',
    NextMonthEnd: 'NextMonthEnd'
} as const;
export type ChecklistItemDtoDeadlineEnum = typeof ChecklistItemDtoDeadlineEnum[keyof typeof ChecklistItemDtoDeadlineEnum];

/**
 * @export
 */
export const ChecklistItemDtoPriorityEnum = {
    High: 'High',
    Medium: 'Medium',
    Low: 'Low'
} as const;
export type ChecklistItemDtoPriorityEnum = typeof ChecklistItemDtoPriorityEnum[keyof typeof ChecklistItemDtoPriorityEnum];


/**
 * Check if a given object implements the ChecklistItemDto interface.
 */
export function instanceOfChecklistItemDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stepDefinitionId" in value;
    isInstance = isInstance && "stepType" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "order" in value;
    isInstance = isInstance && "deadline" in value;
    isInstance = isInstance && "automatic" in value;
    isInstance = isInstance && "priority" in value;
    isInstance = isInstance && "stageDefinitionId" in value;
    isInstance = isInstance && "completed" in value;
    isInstance = isInstance && "statusMessage" in value;

    return isInstance;
}

export function ChecklistItemDtoFromJSON(json: any): ChecklistItemDto {
    return ChecklistItemDtoFromJSONTyped(json, false);
}

export function ChecklistItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChecklistItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stepDefinitionId': json['stepDefinitionId'],
        'stepType': json['stepType'],
        'name': json['name'],
        'order': json['order'],
        'deadline': json['deadline'],
        'automatic': json['automatic'],
        'priority': json['priority'],
        'stageDefinitionId': json['stageDefinitionId'],
        'completed': json['completed'],
        'statusMessage': json['statusMessage'],
        'additionalInfo': !exists(json, 'additionalInfo') ? undefined : ((json['additionalInfo'] as Array<any>).map(GetNoContractAdditionalInfoDtoFromJSON)),
    };
}

export function ChecklistItemDtoToJSON(value?: ChecklistItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stepDefinitionId': value.stepDefinitionId,
        'stepType': value.stepType,
        'name': value.name,
        'order': value.order,
        'deadline': value.deadline,
        'automatic': value.automatic,
        'priority': value.priority,
        'stageDefinitionId': value.stageDefinitionId,
        'completed': value.completed,
        'statusMessage': value.statusMessage,
        'additionalInfo': value.additionalInfo === undefined ? undefined : ((value.additionalInfo as Array<any>).map(GetNoContractAdditionalInfoDtoToJSON)),
    };
}

